import React, { useEffect, useRef, useState } from "react";
import patient from "../../assets/img/patient.jpg";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  ADMINTEMPLATE,
  GET_ASSESMENT_DATA_REPORT,
  GET_ASSESMENT_DATA_REPORT_STREAM,
  GET_BACKGROUND_REPORT,
  GET_BACKGROUND_REPORT_STREAM,
  GET_CLINICAL_INTERVIEW,
  GET_CLINICAL_INTERVIEW_STREAM,
  GET_COLLATERAL_REPORT,
  GET_DIAGNOSE,
  GET_DIAGNOSE_STREAM,
  GET_FORMULATION,
  GET_FORMULATION_STREAM,
  GET_HISTORY_REPORT,
  GET_MENNTAL_STATUS_EXAMINATION,
  GET_MENNTAL_STATUS_EXAMINATION_STREAM,
  GET_PROMPTS,
  GET_PROMPTS_BY_TEMPLATE,
  GET_RECOMMENDATION,
  GET_RECOMMENDATION_STREAM,
  GET_STANRADISED_ASSESSMENT,
  GET_STANRADISED_ASSESSMENT_STREAM,
  GET_USER,
  PATIENT_PAITENT_REPORT_API_URL,
  PATIENT_PAITENT_REPORT_SAVE_API_URL,
  PATIENT_REPORT_API_URL,
} from "../../action/apiPath";
import { CallWithAuth } from "../../action/apiActions";
import MetadataSection from "./MetadataSection";
import moment from "moment";
import { marked } from "marked";
import TurndownService from "turndown";
// import ReactQuill from "react-quill";
import { LOADING_CAPTION, QUILL_FORMATS, QUILL_MODULES } from "../../util/constant";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor
import { showToast, ToastContainer } from "../../util/toastHelper";
import {
  convertImageToBase64,
  reportDateDwonaloadDateFormat,
  safeMarkedWrapper,
} from "../../util/custom";
import { LoaderIndex } from "../../components/Loader/LoaderIndex";
import { Editor } from "@tinymce/tinymce-react";
import { tinymceApiKey, tinymceConfig } from "../../util/tinymceConfig";
import logo from "../../assets/img/logo.svg";

import htmlToPdfMake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import Swal from "sweetalert2";

import withReactContent from "sweetalert2-react-content";
import {
  reactQuillformats,
  reactQuillmodules,
  stripTableTagsWithSpace,
} from "../../util/reactQuillConfig";
import fileDownload from "js-file-download";
import PromptEditor from "../../components/PromptEditor/Index";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const MySwal = withReactContent(Swal);

// Dynamically load fonts
pdfMake.vfs = {
  ...pdfMake.vfs,
  "Roboto-Regular.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-Regular.ttf").default,
  "Roboto-Medium.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-Medium.ttf").default,
  "Roboto-Italic.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-Italic.ttf").default,
  "Roboto-MediumItalic.ttf":
    require("../RelaTiveIntakeSubmitFormDetail/Roboto-MediumItalic.ttf")
      .default,
};

// Define custom fonts
pdfMake.fonts = {
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};
const PatientReportInformationPageReactQuillTemplate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation(); // gives full URL info like ?templateId=...

  const searchParams = new URLSearchParams(location.search);
  const tetemplateId = searchParams.get("templateId");
  const turndownService = new TurndownService();

  const [fieldWithActiveMic, setFieldWithActiveMic] = useState('');
  const onMicChange = (field) => {
    setFieldWithActiveMic(field);
  };

  const [reportData, setReportData] = useState(null);
  const [reportPatientData, setReportPatientData] = useState(null);
  const [templateList, setTemplateList] = useState([]);
  const [hasProfile, setHasProfile] = useState(null);

  const [apiEndPoints, setApiendPoints] = useState([
    {
      endPoint: GET_COLLATERAL_REPORT,
      type: "Collateral Report",
      key: "collateral",
      async: true
    },
    {
      endPoint: GET_BACKGROUND_REPORT_STREAM,
      type: "Background Information",
      key: "background_info",
      stream: true,
      async: true
    },
    {
      endPoint: GET_ASSESMENT_DATA_REPORT_STREAM,
      type: "Assessment Data Report",
      key: "assessment_data",
      stream: true,
      async: true
    },
    {
      endPoint: GET_MENNTAL_STATUS_EXAMINATION_STREAM,
      type: "Mental Status Examination",
      key: "mse",
      stream: true,
      async: true
    },
    {
      endPoint: GET_STANRADISED_ASSESSMENT_STREAM,
      type: "Standardised Assessment",
      key: "standardised_assessment",
      stream: true,
      async: true
    },
    {
      endPoint: GET_CLINICAL_INTERVIEW_STREAM,
      type: "Clinical Interview",
      key: "clinical_interviews",
      stream: true,
      async: true
    },
    {
      endPoint: GET_FORMULATION_STREAM,
      type: "formulation",
      key: "formulation",
      stream: true,
      async: true
    },
    {
      endPoint: GET_DIAGNOSE_STREAM,
      type: "DSM-5-TR/ICD-11 Diagnoses",
      key: "diagnose",
      stream: true,
      async: false
    },
    {
      endPoint: GET_RECOMMENDATION_STREAM,
      type: "Recommendations",
      key: "recommendation",
      stream: true,
      async: false
    },
  ]);
  const editorRef = useRef(null);

  const [collateralGenerated, setCollateralGenerated] = useState(false);
  const [backgroundInfoGenerated, setBackgroundInfoGenerated] = useState(false);
  const [assessmentGenerated, setAssessmentGenerated] = useState(false);
  const [mentalStatusExaminationGenerated, setMentalStatusExaminationGenerated] = useState(false);
  const [standardisedAssessmentGenerated, setStandardisedAssessmentGenerated] = useState(false);
  const [clinicalInterviewsGenerated, setClinicalInterviewsGenerated] = useState(false);
  const [formulationGenerated, setFormulationGenerated] = useState(false);
  const [diagnoseGenerated, setDiagnoseGenerated] = useState(false);
  const [recommendationGenerated, setRecommendationGenerated] = useState(false);

  const [reportgenerateData, setReportgenerateData] = useState({
    background_info: "",
    background_info_with_markdown: "",
    background_info_generated: false,
    background_info_generation_done: false,
    background_info_update_prompt: false,

    assessment_data: "",
    assessment_data_with_markdown: "",
    assessment_data_generated: false,
    assessment_data_generation_done: false,
    assessment_data_update_prompt: false,

    collateral: "",
    collateral_with_markdown: "",
    collateral_generated: false,
    collateral_generation_done: false,
    collateral_update_prompt: false,

    mse: "",
    mse_with_markdown: "",
    mse_generated: false,
    mse_generation_done: false,
    mse_update_prompt: false,

    standardised_assessment: "",
    standardised_assessment_with_markdown: "",
    standardised_assessment_generated: false,
    standardised_assessment_generation_done: false,
    standardised_assessment_update_prompt: false,

    clinical_interviews: "",
    clinical_interviews_with_markdown: "",
    clinical_interviews_generated: false,
    clinical_interviews_generation_done: false,
    clinical_interviews_update_prompt: false,

    formulation: "",
    formulation_with_markdown: "",
    formulation_generated: false,
    formulation_generation_done: false,
    formulation_update_prompt: false,

    diagnose: "",
    diagnose_with_markdown: "",
    diagnose_generated: false,
    diagnose_generation_done: false,
    diagnose_update_prompt: false,

    recommendation: "",
    recommendation_with_markdown: "",
    recommendation_generated: false,
    recommendation_generation_done: false,
    recommendation_update_prompt: false,
  });

  const [promptData, setPromptData] = useState({
    background_info: "background_info",
    assessment_data: "",
    collateral: "",
    mse: "",
    standardised_assessment: "",
    clinical_interviews: "",
    formulation: "",
    diagnose: "",
    recommendation: "",
  });

  const [promptResult, setPromptResult] = useState([]);

  const [currentPromptData, setCurrentPromptData] = useState({
    background_info: "",
    assessment_data: "",
    collateral: "",
    mse: "",
    standardised_assessment: "",
    clinical_interviews: "",
    formulation: "",
    diagnose: "",
    recommendation: "",
  });
  const [reportDisplayStatus, setReportDisplayStatus] = useState({
    background_info: false,
    assessment_data: false,
    history: false,
    collateral: false,
    mse: false,
    standardised_assessment: false,
    clinical_interviews: false,
    formulation: false,
    diagnose: false,
    recommendation: false,
  });
  const [getResults, setResults] = useState([]);
  const [cureentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isReportGenerate, setIsReportGenerate] = useState(false);
  const [reportGenerated, setReportGenerated] = useState(false);
  const [isProptsApiCall, setIsProptsApiCall] = useState(false);

  const [checkreportAppoved, setCheckreportAppoved] = useState(true);

  const [isReportDownload, setIsReportDownload] = useState("");
  const [isReportDocDownload, setIsReportDocDownload] = useState("");
  const [isApprovedLoading, setIsApprovedLoading] = useState("");

  const [isReportApproved, setIsReportApproved] = useState(null);
  const [isReportLimitReached, setIsReportLimitReached] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("userCreateAccountInfo") || localStorage.getItem("userCreateAccountInfo") === "null") {
      setHasProfile(false);
    } else {
      setHasProfile(true)
    }
  }, []);

  useEffect(() => {
    if (hasProfile === false) {
      showToast("error", "Profile not set. Please setup your profile to continue");
    }
  }, [hasProfile]);

  useEffect(() => {
    fetchData();
    if (tetemplateId) {
      getPatientReportApiCall();
      getPatientReportRecordApiCall();
      getProptsDeatils();
    }
  }, [tetemplateId]);

  useEffect(() => {
    if (reportGenerated) {
      setIsLoading(false);
    }
  }, [reportGenerated]);

  useEffect(() => {
    if (isProptsApiCall && !collateralGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "collateral")
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, collateralGenerated]);
  
  useEffect(() => {
    if (isProptsApiCall && collateralGenerated && !backgroundInfoGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "background_info")
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, collateralGenerated, backgroundInfoGenerated]);

  useEffect(() => {
    if (isProptsApiCall && backgroundInfoGenerated && !assessmentGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "assessment_data");
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, backgroundInfoGenerated, assessmentGenerated]);

  useEffect(() => {
    if (isProptsApiCall && backgroundInfoGenerated && !mentalStatusExaminationGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "mse");
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, backgroundInfoGenerated, mentalStatusExaminationGenerated]);

  useEffect(() => {
    if (isProptsApiCall && backgroundInfoGenerated && !clinicalInterviewsGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "clinical_interviews");
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, backgroundInfoGenerated, clinicalInterviewsGenerated]);

  useEffect(() => {
    if (isProptsApiCall && backgroundInfoGenerated && !formulationGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "formulation");
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, backgroundInfoGenerated, formulationGenerated]);

  useEffect(() => {
    if (isProptsApiCall && assessmentGenerated && !standardisedAssessmentGenerated && !reportGenerated) {
      let index = apiEndPoints.findIndex(item => item.key == "standardised_assessment");
      getReportAlldetail(index);
    }
  }, [isProptsApiCall, assessmentGenerated, standardisedAssessmentGenerated]);

  const fetchData = async () => {
      const isTokenAvailable = localStorage.getItem('accessToken');
      if (isTokenAvailable) {
          const header = {
              headers: {
                  Authorization: `Bearer ${isTokenAvailable}`,
              },
          };

          try {
              const response = await axios.get(GET_USER, header);
              if (response.status === 200 || response.status === 201) {
                  if (response?.data?.data?.isAllReportExhausted) {
                    setIsReportLimitReached(true);
                  }
              } else {
                  
              }

          } catch (err) {
              
          } finally {
              
          }
      }
  };

  useEffect(() => {
    if (
      isProptsApiCall && 
      backgroundInfoGenerated && 
      assessmentGenerated && 
      mentalStatusExaminationGenerated && 
      standardisedAssessmentGenerated && 
      clinicalInterviewsGenerated && 
      formulationGenerated && 
      !diagnoseGenerated && 
      !reportGenerated
    ) {
      let index = apiEndPoints.findIndex(item => item.key == "diagnose");
      getReportAlldetail(index);
    }
  }, [
    isProptsApiCall, 
    backgroundInfoGenerated, 
    assessmentGenerated, 
    mentalStatusExaminationGenerated, 
    standardisedAssessmentGenerated, 
    clinicalInterviewsGenerated, 
    formulationGenerated, 
    diagnoseGenerated
  ]);

  useEffect(() => {
    if (
      isProptsApiCall && 
      backgroundInfoGenerated && 
      assessmentGenerated && 
      mentalStatusExaminationGenerated && 
      standardisedAssessmentGenerated && 
      clinicalInterviewsGenerated && 
      formulationGenerated && 
      diagnoseGenerated && 
      !recommendationGenerated && 
      !reportGenerated
    ) {
      let index = apiEndPoints.findIndex(item => item.key == "recommendation");
      getReportAlldetail(index);
    }
  }, [
    isProptsApiCall, 
    backgroundInfoGenerated, 
    assessmentGenerated, 
    mentalStatusExaminationGenerated, 
    standardisedAssessmentGenerated, 
    clinicalInterviewsGenerated, 
    formulationGenerated, 
    diagnoseGenerated, 
    recommendationGenerated
  ]);

  const getProptsDeatils = async () => {
    try {
      const response = await CallWithAuth(
        "GET",
        `${GET_PROMPTS_BY_TEMPLATE}?templateId=${tetemplateId}`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        setIsProptsApiCall(true);
        setPromptResult(response.res.data.data);
      } else {
        setIsProptsApiCall(true);
      }
    } catch (error) {
      setIsProptsApiCall(true);
    }
  }

  const getPatientReportRecordApiCall = async () => {
    try {
      const response = await CallWithAuth(
        "GET",
        `${PATIENT_PAITENT_REPORT_API_URL}${id}`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        setCheckreportAppoved(false);
        setReportPatientData(response.res.data.data);
        if (response.res.data.data?.is_approved) {
          setReportgenerateData((pre) => ({
            ...pre,
            background_info: response?.res?.data?.data?.background_info,
            background_info_with_markdown: response?.res?.data?.data?.background_info ? marked(
              response?.res?.data?.data?.background_info
            ) : "",
            background_info_generated: true,
            background_info_generation_done: true,

            assessment_data: response?.res?.data?.data?.assessment_data,
            assessment_data_with_markdown: response?.res?.data?.data?.assessment_data ? marked(
              response?.res?.data?.data?.assessment_data
            ) : "",
            assessment_data_generated: true,
            assessment_data_generation_done: true,

            collateral: response?.res?.data?.data?.collateral,
            collateral_with_markdown: response?.res?.data?.data?.collateral ? marked(
              response?.res?.data?.data?.collateral
            ) : "",
            collateral_generated: true,
            collateral_generation_done: true,

            mse: response?.res?.data?.data?.mse,
            mse_with_markdown: response?.res?.data?.data?.mse ? marked(response?.res?.data?.data?.mse) : "",
            mse_generated: true,
            mse_generation_done: true,

            standardised_assessment:
              response?.res?.data?.data?.standardised_assessment,
            standardised_assessment_with_markdown: response?.res?.data?.data?.standardised_assessment ? marked(
              response?.res?.data?.data?.standardised_assessment
            ) : "",
            standardised_assessment_generated: true,
            standardised_assessment_generation_done: true,

            clinical_interviews: response?.res?.data?.data?.clinical_interviews,
            clinical_interviews_with_markdown: response?.res?.data?.data?.clinical_interviews ? marked(
              response?.res?.data?.data?.clinical_interviews
            ) : "",
            clinical_interviews_generated: true,
            clinical_interviews_generation_done: true,

            formulation: response?.res?.data?.data?.formulation,
            formulation_with_markdown: response?.res?.data?.data?.formulation ? marked(
              response?.res?.data?.data?.formulation
            ) : "",
            formulation_generated: true,
            formulation_generation_done: true,

            diagnose: response?.res?.data?.data?.diagnose,
            diagnose_with_markdown: response?.res?.data?.data?.diagnose ? marked(response?.res?.data?.data?.diagnose) : "",
            diagnose_generated: true,
            diagnose_generation_done: true,

            recommendation: response?.res?.data?.data?.recommendation,
            recommendation_with_markdown: response?.res?.data?.data?.recommendation ? marked(
              response?.res?.data?.data?.recommendation
            ) : "",
            recommendation_generated: true,
            recommendation_generation_done: true
          }));

          setIsReportGenerate(true);
          setReportGenerated(true);
          setIsReportApproved(true);
        } else {
          setIsReportApproved(false);
        }
      }
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
  };

  useEffect(() => {
    if (isReportApproved !== null) {
      if (!isReportApproved && isReportLimitReached) {
        showToast("error", "You have reached the limit for maximum number of reports");
      }
    }
  }, [isReportApproved, isReportLimitReached]);

  const getPatientReportApiCall = async () => {
    try {
      const response = await CallWithAuth(
        "GET",
        `${PATIENT_REPORT_API_URL}${id}/?extra=true`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        setReportData(response.res.data.data);
      }
    } catch (error) {
      console.error("Error fetching practice frameworks:", error);
    }
  };

  const streamCallWithAuth = async (url, body) => {
    const token = localStorage.getItem('accessToken'); // Or however you get your auth token
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(body),
    });
  };

  const getReportAlldetail = async (_cureentIndex) => {
    try {
      if (apiEndPoints[_cureentIndex].endPoint != undefined) {
        const currentKey = apiEndPoints[_cureentIndex].key;
        const currentEndPoint = apiEndPoints[_cureentIndex].endPoint;
        const findPropmts = promptResult.find((item) => item.apiEndpointName === apiEndPoints[_cureentIndex].key);

        if (isReportLimitReached) {
          if (apiEndPoints[_cureentIndex].endPoint === GET_RECOMMENDATION_STREAM) {
            setIsReportGenerate(true);
          }

          setReportgenerateData((prev) => ({
            ...prev,
            [apiEndPoints[_cureentIndex].key]: 'You have reached the maximum number of reports allowed by your subscription plan. Please upgrade your plan or contact support for more information.',
            [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: marked('You have reached the maximum number of reports allowed by your subscription plan. Please upgrade your plan or contact support for more information.'),
            [`${apiEndPoints[_cureentIndex].key}_generated`]: true,
            [`${apiEndPoints[_cureentIndex].key}_generation_done`]: true,
          }));

          setIsLoading(false);

        } else if (findPropmts != undefined) {
          // if (apiEndPoints[_cureentIndex]?.async && apiEndPoints[_cureentIndex + 1]?.async) {
          //   setCurrentIndex(_cureentIndex + 1);
          // }

          if (apiEndPoints[_cureentIndex].stream) {
            const response = await streamCallWithAuth(`${currentEndPoint}${id}`, {
              prompt_text: findPropmts?.promtText
            });

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let accumulatedText = "";

            // 2. Read the stream
            while (true) {
              const { value, done } = await reader.read();

              const chunk = decoder.decode(value, { stream: true });

              let resp = null;
              try {
                resp = JSON.parse(chunk);
              } catch (e) { }

              if (resp?.error) {
                if (accumulatedText.trim()) {
                  accumulatedText += "\n\n" + resp.message;
                } else {
                  accumulatedText = resp.message;
                }
                setReportgenerateData((prev) => ({
                  ...prev,
                  [apiEndPoints[_cureentIndex].key]: accumulatedText,
                  [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: marked(accumulatedText),
                  [`${apiEndPoints[_cureentIndex].key}_generated`]: done,
                }));
              }

              if (done) {
                setReportgenerateData((prev) => ({
                  ...prev,
                  [`${apiEndPoints[_cureentIndex].key}_generated`]: done,
                  [`${apiEndPoints[_cureentIndex].key}_generation_done`]: true,
                }));
                break;
              }

              // 3. Parse SSE format (data: {"chunk": "..."})
              const lines = chunk.split("\n\n");
              lines.forEach(line => {
                if (line.startsWith("data: ")) {
                  try {
                    const data = JSON.parse(line.replace("data: ", ""));

                    if (data.chunk) {
                      accumulatedText += data.chunk.replaceAll("data: ", "").replaceAll("\n\ndata: ", "").replace(/\n\n$/, '');

                      // 4. Update state in real-time
                      setReportgenerateData((prev) => ({
                        ...prev,
                        [apiEndPoints[_cureentIndex].key]: accumulatedText,
                        [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: marked(accumulatedText),
                        [`${apiEndPoints[_cureentIndex].key}_generated`]: true
                      }));
                    }

                    if (data.status === 'done') {
                      console.log("Streaming complete");
                    }
                  } catch (e) {
                    console.log(e);
                    setReportgenerateData((prev) => ({
                      ...prev,
                      [apiEndPoints[_cureentIndex].key]: "Report Not Generated",
                      [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: "Report Not Generated",
                      [`${apiEndPoints[_cureentIndex].key}_generated`]: true,
                    }));
                    console.error("Error parsing stream chunk", e);
                  }
                }
              });
            }

            if (apiEndPoints[_cureentIndex].endPoint === GET_RECOMMENDATION_STREAM) {
              setIsReportGenerate(true);
            }

            // Move to next section after background info is finished
            // if (!apiEndPoints[_cureentIndex].async) {
              setCurrentIndex(_cureentIndex + 1);
            // }
          } else {
            const response = await CallWithAuth(
              "POST",
              `${apiEndPoints[_cureentIndex].endPoint}${id}`,
              { prompt_text: findPropmts?.promtText }
            );

            if (response?.res?.data?.statusCode === 200) {
              if (
                apiEndPoints[_cureentIndex].endPoint === GET_BACKGROUND_REPORT &&
                response?.res?.data?.data?.is_approved
              ) {
                setReportgenerateData((pre) => ({
                  ...pre,
                  background_info: response?.res?.data?.data?.background_info,
                  background_info_with_markdown: response?.res?.data?.data?.background_info ? marked(
                    response?.res?.data?.data?.background_info
                  ) : "",
                  background_info_generated: true,
                  background_info_generation_done: true,

                  assessment_data: response?.res?.data?.data?.assessment_data,
                  assessment_data_with_markdown: response?.res?.data?.data?.assessment_data ? marked(
                    response?.res?.data?.data?.assessment_data
                  ) : "",
                  assessment_data_generated: true,
                  assessment_data_generation_done: true,

                  collateral: response?.res?.data?.data?.collateral,
                  collateral_with_markdown: response?.res?.data?.data?.collateral ? marked(
                    response?.res?.data?.data?.collateral
                  ) : "",
                  collateral_generated: true,
                  collateral_generation_done: true,

                  mse: response?.res?.data?.data?.mse,
                  mse_with_markdown: response?.res?.data?.data?.mse ? marked(response?.res?.data?.data?.mse) : "",
                  mse_generated: true,
                  mse_generation_done: true,

                  standardised_assessment:
                    response?.res?.data?.data?.standardised_assessment,
                  standardised_assessment_with_markdown: response?.res?.data?.data?.standardised_assessment ? marked(
                    response?.res?.data?.data?.standardised_assessment
                  ) : '',
                  standardised_assessment_generated: true,
                  standardised_assessment_generation_done: true,

                  clinical_interviews:
                    response?.res?.data?.data?.clinical_interviews,
                  clinical_interviews_with_markdown: response?.res?.data?.data?.clinical_interviews ? marked(
                    response?.res?.data?.data?.clinical_interviews
                  ) : '',
                  clinical_interviews_generated: true,
                  clinical_interviews_generation_done: true,

                  formulation: response?.res?.data?.data?.formulation,
                  formulation_with_markdown: response?.res?.data?.data?.formulation ? marked(
                    response?.res?.data?.data?.formulation
                  ) : '',
                  formulation_generated: true,
                  formulation_generation_done: true,

                  diagnose: response?.res?.data?.data?.diagnose,
                  diagnose_with_markdown: response?.res?.data?.data?.diagnose ? marked(
                    response?.res?.data?.data?.diagnose
                  ) : "",
                  diagnose_generated: true,
                  diagnose_generation_done: true,

                  recommendation: response?.res?.data?.data?.recommendation,
                  recommendation_with_markdown: response?.res?.data?.data?.recommendation ? marked(
                    response?.res?.data?.data?.diagnose
                  ) : "",
                  recommendation_generated: true,
                  recommendation_generation_done: true,
                }));

                setIsReportGenerate(true);
                setReportGenerated(true);

              } else {
                setReportgenerateData((prevResults) => ({
                  ...prevResults,
                  [apiEndPoints[_cureentIndex].key]:
                    response?.res?.data?.data?.[apiEndPoints[_cureentIndex].key],
                  [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: response?.res?.data?.data?.[apiEndPoints[_cureentIndex].key] ? marked(
                    response?.res?.data?.data?.[apiEndPoints[_cureentIndex].key]
                  ) : "Report Not Generated",
                  [`${apiEndPoints[_cureentIndex].key}_generated`]: true,
                  [`${apiEndPoints[_cureentIndex].key}_generation_done`]: true,
                }));
              }

              if (apiEndPoints[_cureentIndex].endPoint === GET_RECOMMENDATION_STREAM) {
                setIsReportGenerate(true);
              }
            } else {
              if (apiEndPoints[_cureentIndex].endPoint === GET_RECOMMENDATION_STREAM) {
                setIsReportGenerate(true);
              }

              setReportgenerateData((prevResults) => ({
                ...prevResults,
                [apiEndPoints[_cureentIndex].key]: response?.res?.data?.message,
                [`${apiEndPoints[_cureentIndex].key}_with_markdown`]: response?.res?.data?.message,
                [`${apiEndPoints[_cureentIndex].key}_generated`]: true,
                [`${apiEndPoints[_cureentIndex].key}_generation_done`]: true,
              }));
            }

            // if (!apiEndPoints[_cureentIndex + 1]?.async) {
              setCurrentIndex(_cureentIndex + 1);
            // }
          }

        } else {
          if (apiEndPoints[_cureentIndex].endPoint === GET_RECOMMENDATION_STREAM) {
            setIsReportGenerate(true);
          }

          setIsLoading(false);
        }

        if (currentKey == "collateral") {
          setCollateralGenerated(true);
        }
        else if (currentKey == "background_info") {
          setBackgroundInfoGenerated(true);
        }
        else if (currentKey == "assessment_data") {
          setAssessmentGenerated(true);
        }
        else if (currentKey == "mse") {
          setMentalStatusExaminationGenerated(true);
        }
        else if (currentKey == "standardised_assessment") {
          setStandardisedAssessmentGenerated(true);
        }
        else if (currentKey == "clinical_interviews") {
          setClinicalInterviewsGenerated(true);
        }
        else if (currentKey == "formulation") {
          setFormulationGenerated(true);
        }
        else if (currentKey == "diagnose") {
          setDiagnoseGenerated(true);
        }
        else if (currentKey == "recommendation") {
          setRecommendationGenerated(true);
        }
      }

    } catch (error) {

    }

    setIsLoading(false);
  };

  const handleEditorChange = (section, val) => {
    setTimeout(adjustHeight, 0); // Adjust height after rendering
    setReportDisplayStatus((prevResults) => ({
      ...prevResults,
      [section]: !val,
    }));
  };

  const handleChange = (fieldName, value) => {
    // Update state or perform any other actions based on fieldName and value
    console.log(fieldName, value); // 'background_info', the value from ReactQuill
    setReportgenerateData((prevResults) => ({
      ...prevResults,
      // [fieldName]: turndownService.turndown(editorData),
      [fieldName]: value,
      [`${fieldName}_with_markdown`]: marked(value),
    }));
  };

  const handleApprove = async () => {
    const result = await MySwal.fire({
      title:
        "Are you sure you want to approve the report? Please download the report, as it will be deleted after 30 days.",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve report!",
    });
    if (result.isConfirmed) {
      try {
        let updated = false;
        if (reportgenerateData.assessment_data_update_prompt || reportgenerateData.collateral_update_prompt
          || reportgenerateData.formulation_update_prompt || reportgenerateData.diagnose_update_prompt
          || reportgenerateData.recommendation_update_prompt || reportgenerateData.background_info_update_prompt
          || reportgenerateData.mse_update_prompt || reportgenerateData.standardised_assessment_update_prompt
          || reportgenerateData.clinical_interviews_update_prompt || reportgenerateData.history_update_prompt
        ) {
          updated = true;
        }
        // setIsApprovedLoading(true);
        let obj = {
          background_info: stripTableTagsWithSpace(
            reportgenerateData.background_info
          ),
          collateral: stripTableTagsWithSpace(reportgenerateData.collateral),
          mse: stripTableTagsWithSpace(reportgenerateData.mse),
          standardised_assessment: stripTableTagsWithSpace(
            reportgenerateData.standardised_assessment
          ),
          clinical_interviews: stripTableTagsWithSpace(
            reportgenerateData.clinical_interviews
          ),
          history: stripTableTagsWithSpace(reportgenerateData.history),

          formulation: stripTableTagsWithSpace(reportgenerateData.formulation),
          diagnose: stripTableTagsWithSpace(reportgenerateData.diagnose),
          recommendation: stripTableTagsWithSpace(reportgenerateData.recommendation),
          assessment_data: stripTableTagsWithSpace(reportgenerateData.assessment_data),
          is_approved: true,
        };
        const response = await CallWithAuth(
          "PATCH",
          `${PATIENT_PAITENT_REPORT_SAVE_API_URL}${id}`,
          obj
        );
        if (response?.res?.data?.statusCode === 200) {
          showToast("success", "Report has been saved successfully.");
          setReportGenerated(true);
        } else {
          showToast("error", response.res.data.message);
        }
        setIsApprovedLoading(false);
      } catch (error) {
        setIsApprovedLoading(false);
        console.log("error", error);
      }
    }
  };

  const handleDownloadPdf = async () => {
    setIsReportDownload(true);console.log(reportgenerateData);

    const formattedHtml = Object.entries(reportgenerateData)
      .filter(
        ([key]) =>
          !key.endsWith("_generated") && !key.endsWith("_generation_done") && !key.endsWith("_with_markdown") && !key.endsWith("_update_prompt")
      ) // Remove "_generated" keys
      .map(([key, value]) => {
        // Format key: Replace "_" with space and capitalize words
        let formattedKey = key
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
        console.log("formattedKey", formattedKey);

        // Replace "Diagnose" with "Impressions and Diagnosis"
        if (formattedKey != 'Collateral') {
          // Replace "Diagnose" with "Impressions and Diagnosis"
          if (formattedKey === "Diagnose") {
            formattedKey = "Impressions and Diagnosis";
          }
          if (formattedKey == 'Background Info') {
            formattedKey = "Background";
          }
          return `<h3>${formattedKey}</h3> ${value ? marked(value) : ""}`; // Add as HTML

        } else {
          return "";
        }
      })
      .join(" "); // Join all HTML
    let base64Logo = await convertImageToBase64(logo);

    const convertedContent = htmlToPdfMake(formattedHtml);
    const docDefinition = {
      pageSize: "A4", // Default is A4
      pageOrientation: "prtrait", // Set landscape mode
      content: [
        {
          image: base64Logo, // Insert the Base64 logo
          width: 100, // Adjust size
          alignment: "center", // Center align the logo
          margin: [0, 0, 0, 20], // Space below the logo
        },
        convertedContent, // Insert the formatted content
      ],
    };
    const fullName = reportData?.full_name
      ? reportData.full_name.replace(/\s+/g, "_")
      : "";

    const filename = reportData?.full_name
      ? `${fullName}_document_${reportDateDwonaloadDateFormat()}.pdf`
      : `document_${reportDateDwonaloadDateFormat()}.pdf`;

    // Now use pdfmake to generate PDF
    pdfMake.createPdf(docDefinition).download(filename);
    setIsReportDownload(false);

    // 🔹 Create a new DOM element with the concatenated HTM  L
  };

  const handleDownloadDoc = async () => {
    setIsReportDocDownload(true);
    const formattedHtml = Object.entries(reportgenerateData)
      .filter(
        ([key]) =>
          !key.endsWith("_generated") && !key.endsWith("_generation_done") && !key.endsWith("_with_markdown") && !key.endsWith("_update_prompt")
      ) // Remove "_generated" "_with_markdown" keys
      .map(([key, value]) => {

        // Format key: Replace "_" with space and capitalize words
        let formattedKey = key
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

        if (formattedKey != 'Collateral') {
          // Replace "Diagnose" with "Impressions and Diagnosis"
          if (formattedKey === "Diagnose") {
            formattedKey = "Impressions and Diagnosis";
          }
          if (formattedKey == 'Background Info') {
            formattedKey = "Background";
          }
          return `<h3>${formattedKey}</h3> ${value ? marked(value) : ""}`; // Add as HTML
        } else {
          return;
        }
        // return `<h3>${formattedKey}</h3> ${value}`; // Add as HTML
      })
      .join(" "); // Join all HTML
    let base64Logo = await convertImageToBase64(logo);

    const fullName = reportData?.full_name
      ? reportData.full_name.replace(/\s+/g, "_")
      : "";

    const filename = reportData?.full_name
      ? `${fullName}_document_${reportDateDwonaloadDateFormat()}.doc`
      : `document_${reportDateDwonaloadDateFormat()}.doc`;
    // Add logo to HTML using <img>
    const logo_section_html = `
<div style="text-align: center; margin-bottom: 20px;">
  <img src="${base64Logo}" alt="Logo" style="width: 150px; height: auto;" />
</div>`;

    // Convert HTML to Blob
    const blob = new Blob(
      [
        ` <html>
        <head>
          <meta charset="UTF-8">
          <title>Document</title>
        </head><body>${logo_section_html}${formattedHtml}</body>
      </html>`,
      ],
      { type: "application/msword" }
    );

    // Option 1: Use js-file-download (Optional)
    fileDownload(blob, filename);
    setIsReportDocDownload(false);
  };
  const textareaRef = useRef(null);

  const adjustHeight = () => {
    if (textareaRef.current) {
      // textareaRef.current.style.height = '40px'; // Reset to initial height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Adjust to content
    }
  };

  const handleTestPrompt = (reportData, field) => {
    setReportgenerateData((prevResults) => ({
      ...prevResults,
      [field]: reportData,
      [`${field}_with_markdown`]: reportData ? marked(reportData) : "",
    }));
  };

  const handleUpdatePrompt = (reportData, field, promptValue, done) => {
    setReportgenerateData((prevResults) => ({
      ...prevResults,
      [field]: reportData,
      [`${field}_with_markdown`]: reportData ? marked(reportData) : "",
    }));
    if (done) {
      setReportgenerateData((prevResults) => ({
        ...prevResults,
        [`${field}_update_prompt`]: false,
      }));
      getProptsDeatils();
    }
  }

  const handlePromptInputChange = (fieldName, value) => {
    setPromptData((prev) => {
      return {
        ...prev,
        [fieldName]: value,
      };
    });
  }

  const handleChangePrompt = (fieldName, value) => {
    if (!value) {
      const findPropmts = promptResult.find((item) => item.apiEndpointName === fieldName);

      setReportgenerateData((prevResults) => ({
        ...prevResults,
        [`${fieldName}_update_prompt`]: !value,
      }));
      setPromptData((prevResults) => ({
        ...prevResults,
        [fieldName]: findPropmts?.promtText,
      }));
      if (currentPromptData[fieldName] == '') {//check if the prompt is empty
        setCurrentPromptData((prevResults) => ({
          ...prevResults,
          [fieldName]: findPropmts?.promtText,
          [`${fieldName}_previous_value`]: reportgenerateData[`${fieldName}`],
        }));
      }
    } else {
      setReportgenerateData((prevResults) => ({
        ...prevResults,
        [`${fieldName}_update_prompt`]: !value,
        [`${fieldName}_with_markdown`]: marked(currentPromptData[`${fieldName}_previous_value`]),
        [`${fieldName}`]: currentPromptData[`${fieldName}_previous_value`],
      }));
      setPromptData((prevResults) => ({
        ...prevResults,
        [fieldName]: currentPromptData[fieldName],
      }));
      setCurrentPromptData((prevResults) => ({
        ...prevResults,
        [fieldName]: promptData[fieldName],
      }));
    }
  }
  const handleReset = async (fieldName, value) => {
    try {
      setReportgenerateData((prevResults) => ({
        ...prevResults,
        [`${fieldName}_update_prompt`]: false,
      }));

      setCurrentPromptData((prevResults) => ({
        ...prevResults,
        [fieldName]: value?.promtText,
      }));

      setPromptData((prevResults) => ({
        ...prevResults,
        [fieldName]: value?.promtText,
      }));

      const response = await CallWithAuth(
        "GET",
        `${GET_PROMPTS_BY_TEMPLATE}?templateId=${tetemplateId}`
      );
      if (response.res.data && response.res.data.statusCode === 200) {
        let propmptsResult = response.res.data.data;
        setPromptResult(propmptsResult);
      }
    } catch (error) {

    }

  }
  const getTemplateData = async () => {
    try {
      const response = await CallWithAuth("GET", ADMINTEMPLATE);
      if (response.res.status == 200) {
        setTemplateList(response?.res?.data?.data);
      } else {
        showToast("error", response.res.data.message);
      }
    } catch (err) {
      console.log(err)
    }
  };

  const renderAssessments = () => {
    const _files = reportData?.assessments?.filter(item => item.assessment_report);
    
    if (!_files?.length) return null;
  
    return (
      <div className="file-list-container row g-3 mt-3">
        {_files.map((item, i) => {
          const parts = item.assessment_report.split("/");
          const name = parts[parts.length - 1];
          const extension = name.split(".").pop().toLowerCase();
          const filename = item.file_name || name;
          const isPdf = extension === 'pdf';
  
          return (
            <div key={i} className="col-sm-6">
              <div className="file-item p-3 border rounded d-flex align-items-center bg-white shadow-sm h-100 position-relative">
                
                {/* Status & Action Icons Container */}
                <div className="position-absolute d-flex align-items-center gap-2" style={{ top: '8px', right: '10px' }}>
                  {/* Success Checkmark */}
                  {item.transcription_text && item.transcription_text !== '' && (
                    <span className="text-success">
                      <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                      </svg>
                    </span>
                  )}
                </div>
  
                <div className="d-flex align-items-center gap-3 w-100 mt-1">
                  {/* Dynamic Icon Section */}
                  <div className={`icon-circle p-2 rounded-circle ${isPdf ? 'bg-success-subtle' : 'bg-primary-subtle'}`}>
                    {isPdf ? (
                      <svg width="20" height="20" fill="currentColor" className="text-success" viewBox="0 0 16 16">
                        <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
                      </svg>
                    ) : (
                      <svg width="20" height="20" fill="currentColor" className="text-primary" viewBox="0 0 16 16">
                        <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"/><path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0v5z"/>
                      </svg>
                    )}
                  </div>
  
                  {/* Text Section */}
                  <div className="flex-grow-1 overflow-hidden pe-4">
                    <a 
                      className="text-truncate d-block fw-medium text-decoration-none text-primary" 
                      style={{ maxWidth: "100%" }} 
                      href={item.assessment_report} 
                      target="_blank" 
                      rel="noreferrer"
                      title={filename}
                    >
                      {filename}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderSessionFiles = (type) => {
    if (type == "assessment") {
      return renderAssessments();
    }
  
    const _files = reportData?.record_sessions?.filter(item => (item.file || item.speech_url) && item.session_type === type);
    
    if (!_files?.length) return null;
  
    return (
      <div className="file-list-container row g-3 mt-3">
        {_files.map((item, i) => {
          let isPdf = false;
          let filename = '';
          if (item.file) {
            const parts = item.file.split("/");
            const name = parts[parts.length - 1];
            const extension = name.split(".").pop().toLowerCase();
            isPdf = extension === 'pdf';
            filename = item.file_name || name;
          } else if (item.speech_url) {
            filename = 'Audio Recording';
          }
  
          return (
            <div key={i} className="col-sm-6">
              <div className="file-item p-3 border rounded d-flex align-items-center bg-white shadow-sm h-100 position-relative">
                
                {/* Status & Action Icons Container */}
                <div className="position-absolute d-flex align-items-center gap-2" style={{ top: '8px', right: '10px' }}>
                  {/* Success Checkmark */}
                  {item.transcription_text && item.transcription_text !== '' && (
                    <span className="text-success">
                      <svg width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                      </svg>
                    </span>
                  )}
                </div>
  
                <div className="d-flex align-items-center gap-3 w-100 mt-1">
                  {/* Dynamic Icon Section */}
                  <div className={`icon-circle p-2 rounded-circle ${isPdf ? 'bg-success-subtle' : 'bg-primary-subtle'}`}>
                    {isPdf ? (
                      <svg width="20" height="20" fill="currentColor" className="text-success" viewBox="0 0 16 16">
                        <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/><path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
                      </svg>
                    ) : (
                      <svg width="20" height="20" fill="currentColor" className="text-primary" viewBox="0 0 16 16">
                        <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5z"/><path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0v5z"/>
                      </svg>
                    )}
                  </div>
  
                  {/* Text Section */}
                  <div className="flex-grow-1 overflow-hidden pe-4">
                    <a 
                      className="text-truncate d-block fw-medium text-decoration-none text-primary" 
                      style={{ maxWidth: "100%" }} 
                      href={item.file} 
                      target="_blank" 
                      rel="noreferrer"
                      title={filename}
                    >
                      {filename}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="create_account_block patient-report-information-template">
      <div className="site_container">
        <div className="create_account_form">
          <>
            {!reportGenerated && (<>
              <div className="report-container-main px-0"><p style={{ color: "red", fontWeight: "bold" }} className="text-center">Please note that while editing the report, don't change any special characters like **, ####, -, **, **,, or ###, as they are used purposefully.</p></div>
            </>)}
            {reportgenerateData.mse_generated && <></>}
            <div className="report-container-main px-0">
              <h1>background</h1>
              <div
                className="report-container-child-cls typing"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                {!reportDisplayStatus?.background_info && (
                  <>
                    <div
                      style={{
                        fontSize: "20px",
                        padding: "24px",
                        background: "#F9FAFC",
                        borderRadius: "10px",
                        width: "100%",
                        color: isReportLimitReached && !isReportApproved ? "red" : ""
                      }}
                      className="form-group report-container-new"
                      dangerouslySetInnerHTML={{
                        __html: reportgenerateData?.background_info_generated
                          ? reportgenerateData?.background_info_with_markdown ?? ""
                          : LOADING_CAPTION,
                      }}
                    />
                     {!reportgenerateData?.background_info_generation_done && (
                      <div className="loader-with-text">
                        <div className="loader-div">
                        <LoaderIndex />
                      </div>
                      <div className="text-div loading-text">
                        Generating Reports
                        <span className="dots">
                          <span>.</span>
                          <span>.</span>
                          <span>.</span>
                        </span>
                      </div>
                      </div>
                    )}
                    {!reportGenerated && !isReportLimitReached && (
                      <>
                        <div className={!reportgenerateData.background_info_update_prompt ? 'd-flex' : ""}>
                          {!reportgenerateData.background_info_update_prompt && (<>
                            <button
                              onClick={(e) =>
                                handleEditorChange(
                                  "background_info",
                                  reportDisplayStatus.background_info
                                )
                              }
                              disabled={!reportgenerateData?.background_info_generation_done}
                            >
                              Edit
                            </button>
                          </>
                          )}

                          {!reportgenerateData.background_info_update_prompt ? (
                            <button
                              onClick={(e) =>
                                handleChangePrompt(
                                  "background_info",
                                  reportgenerateData.background_info_update_prompt
                                )
                              }
                              disabled={!reportgenerateData?.background_info_generation_done}
                              className="ms-4"
                            >
                              Edit Prompts
                            </button>
                          ) : (
                            <>
                              <PromptEditor
                                field="background_info"
                                promptValue={promptData?.background_info || ""}
                                onChange={handlePromptInputChange}
                                onTest={handleTestPrompt}
                                onUpdate={handleUpdatePrompt}
                                onCancel={handleChangePrompt}
                                onReset={handleReset}
                                cancelValue={reportgenerateData.background_info_update_prompt}
                                promptResult={promptResult}
                                isMiceActive={fieldWithActiveMic == "background_info"}
                                onMicChange={onMicChange}
                              />
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </>
                )}

                {reportDisplayStatus?.background_info && (
                  <>
                    <textarea
                      onInput={adjustHeight}
                      value={reportgenerateData.background_info ?? ""}
                      onChange={(e) =>
                        handleChange("background_info", e.target.value)
                      }
                      ref={textareaRef}
                      className="form-control pe-5"
                    />
                    <button
                      onClick={(e) =>
                        handleEditorChange(
                          "background_info",
                          reportgenerateData.background_info
                        )
                      }
                      className="view-report-button"
                    >
                      View
                    </button>
                  </>
                )}
              </div>
             
              {/* {renderSessionFiles("background_info_audio")}
              {renderSessionFiles("background_info_pdf")} */}
            </div>
            <hr className="border border-dark border-3 opacity-100" />
            {/*End background info */}

            <div className="report-container-main px-0 pt-3">
              <h1>assessment data</h1>
              <div
                className="report-container-child-cls"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                {!reportDisplayStatus?.assessment_data && (
                  <>
                    <div
                      style={{
                        fontSize: "20px",
                        padding: "24px",
                        background: "#F9FAFC",
                        borderRadius: "10px",
                        width: "100%",
                        color: isReportLimitReached && !isReportApproved ? "red" : ""
                      }}
                      className="form-group report-container-new"
                      dangerouslySetInnerHTML={{
                        __html: reportgenerateData?.assessment_data
                          ? reportgenerateData?.assessment_data_with_markdown ?? ""
                          : LOADING_CAPTION,
                      }}
                    />
                    {!reportgenerateData?.assessment_data_generation_done && (
                      <div className="loader-with-text">
                        <div className="loader-div">
                        <LoaderIndex />
                      </div>
                      <div className="text-div loading-text">
                        Generating Reports
                        <span className="dots">
                          <span>.</span>
                          <span>.</span>
                          <span>.</span>
                        </span>
                      </div>
                      </div>
                    )}
                    {!reportGenerated && !isReportLimitReached && (
                      <>
                        <div className={!reportgenerateData.assessment_data_update_prompt ? 'd-flex' : ""}>
                          {!reportgenerateData.assessment_data_update_prompt && (<>
                            <button
                              onClick={(e) =>
                                handleEditorChange(
                                  "assessment_data",
                                  reportDisplayStatus.assessment_data
                                )
                              }
                              disabled={!reportgenerateData?.assessment_data_generation_done}
                            >
                              Edit
                            </button>
                          </>
                          )}

                          {!reportgenerateData.assessment_data_update_prompt ? (
                            <button
                              onClick={(e) =>
                                handleChangePrompt(
                                  "assessment_data",
                                  reportgenerateData.assessment_data_update_prompt
                                )
                              }
                              disabled={!reportgenerateData?.assessment_data_generation_done}
                              className="ms-4"
                            >
                              Edit Prompts
                            </button>
                          ) : (
                            <>
                              <PromptEditor
                                field="assessment_data"
                                promptValue={promptData?.assessment_data || ""}
                                onChange={handlePromptInputChange}
                                onTest={handleTestPrompt}
                                onUpdate={handleUpdatePrompt}
                                onCancel={handleChangePrompt}
                                onReset={handleReset}
                                cancelValue={reportgenerateData.assessment_data_update_prompt}
                                promptResult={promptResult}
                                isMiceActive={fieldWithActiveMic == "assessment_data"}
                                onMicChange={onMicChange}
                              />
                            </>
                          )}

                        </div>
                      </>
                    )}
                  </>
                )}

                {reportDisplayStatus?.assessment_data && (
                  <>
                    <textarea
                      onInput={adjustHeight}
                      value={reportgenerateData.assessment_data ?? ""}
                      onChange={(e) =>
                        handleChange("assessment_data", e.target.value)
                      }
                      ref={textareaRef}
                      className="form-control pe-5"
                    />
                    <button
                      onClick={(e) =>
                        handleEditorChange(
                          "assessment_data",
                          reportgenerateData.assessment_data
                        )
                      }
                      className="view-report-button"
                    >
                      View
                    </button>
                  </>
                )}
              </div>
              {/* {renderSessionFiles("background_info_audio")}
              {renderSessionFiles("background_info_pdf")} */}
            </div>
            <hr className="border border-dark border-3 opacity-100" />

            {/* Mental Status Examination info */}

            {/* {reportgenerateData.mse_generated && ( */}
            <>
              <div className="report-container-main px-0 mt-3">
                <h1>Mental Status Examination</h1>
              
                <div
                  className="report-container-child-cls"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  {!reportDisplayStatus?.mse && (
                    <>
                      <div
                        style={{
                          fontSize: "20px",
                          padding: "24px",
                          background: "#F9FAFC",
                          borderRadius: "10px",
                          width: "100%",
                          color: isReportLimitReached && !isReportApproved ? "red" : ""
                        }}
                        className="form-group report-container-new"
                        dangerouslySetInnerHTML={{
                          __html: reportgenerateData?.mse_generated
                            ? reportgenerateData?.mse_with_markdown ?? ""
                            : LOADING_CAPTION,
                        }}
                      />
                      {!reportgenerateData?.mse_generation_done && (
                        <div className="loader-with-text">
                          <div className="loader-div">
                          <LoaderIndex />
                        </div>
                        <div className="text-div loading-text">
                          Generating Reports
                          <span className="dots">
                            <span>.</span>
                            <span>.</span>
                            <span>.</span>
                          </span>
                        </div>
                        </div>
                      )}
                      {!reportGenerated && !isReportLimitReached && (
                        <>
                          <div className={!reportgenerateData.mse_update_prompt ? 'd-flex' : ""}>
                            {!reportgenerateData.mse_update_prompt && (<>
                              <button
                                onClick={(e) =>
                                  handleEditorChange(
                                    "mse",
                                    reportDisplayStatus.mse
                                  )
                                }
                                disabled={!reportgenerateData?.mse_generation_done}
                              >
                                Edit
                              </button>
                            </>
                            )}

                            {!reportgenerateData.mse_update_prompt ? (
                              <button
                                onClick={(e) =>
                                  handleChangePrompt(
                                    "mse",
                                    reportgenerateData.mse_update_prompt
                                  )
                                }
                                disabled={!reportgenerateData?.mse_generation_done}
                                className="ms-4"
                              >
                                Edit Prompts
                              </button>
                            ) : (
                              <>
                                <PromptEditor
                                  field="mse"
                                  promptValue={promptData?.mse || ""}
                                  onChange={handlePromptInputChange}
                                  onTest={handleTestPrompt}
                                  onUpdate={handleUpdatePrompt}
                                  onCancel={handleChangePrompt}
                                  onReset={handleReset}
                                  cancelValue={reportgenerateData.mse_update_prompt}
                                  promptResult={promptResult}
                                  isMiceActive={fieldWithActiveMic == "mse"}
                                  onMicChange={onMicChange}
                                />
                              </>
                            )}
                          </div>
                        </>
                      )}
                    </>
                  )}

                  {reportDisplayStatus?.mse && (
                    <>
                      <textarea
                        onInput={adjustHeight}
                        value={reportgenerateData.mse ?? ""}
                        onChange={(e) => handleChange("mse", e.target.value)}
                        ref={textareaRef}
                        className="form-control pe-5"
                      />
                      <button
                        onClick={(e) =>
                          handleEditorChange("mse", reportgenerateData.mse)
                        }
                        className="view-report-button"
                      >
                        View
                      </button>
                    </>
                  )}
                </div>

                {/* {renderSessionFiles("mse")} */}
              </div>
              <hr className="border border-dark border-3 opacity-100" />
            </>

            {/* End Mental Status Examination info */}

            {/* standardised assessment info */}
            <>
              <div className="report-container-main px-0 mt-3">
                <h1>standardised assessment</h1>
                  
                <div
                  className="report-container-child-cls"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  {!reportDisplayStatus?.standardised_assessment && (
                    <>
                      <div
                        style={{
                          fontSize: "20px",
                          padding: "24px",
                          background: "#F9FAFC",
                          borderRadius: "10px",
                          width: "100%",
                          color: isReportLimitReached && !isReportApproved ? "red" : ""
                        }}
                        className="form-group report-container-new"
                        dangerouslySetInnerHTML={{
                          __html: reportgenerateData?.standardised_assessment_generated
                            ? reportgenerateData?.standardised_assessment_with_markdown ?? ""
                            : LOADING_CAPTION,
                        }}
                      />
                      {!reportgenerateData?.standardised_assessment_generation_done && (
                        <div className="loader-with-text">
                          <div className="loader-div">
                          <LoaderIndex />
                        </div>
                        <div className="text-div loading-text">
                          Generating Reports
                          <span className="dots">
                            <span>.</span>
                            <span>.</span>
                            <span>.</span>
                          </span>
                        </div>
                        </div>
                      )}
                      {!reportGenerated && !isReportLimitReached && (
                        <>
                          <div className={!reportgenerateData.standardised_assessment_update_prompt ? 'd-flex' : ""}>
                            {!reportgenerateData.standardised_assessment_update_prompt && (<>
                              <button
                                onClick={(e) =>
                                  handleEditorChange(
                                    "standardised_assessment",
                                    reportDisplayStatus.standardised_assessment
                                  )
                                }
                                disabled={!reportgenerateData?.standardised_assessment_generation_done}
                              >
                                Edit
                              </button>
                            </>
                            )}

                            {!reportgenerateData.standardised_assessment_update_prompt ? (
                              <button
                                onClick={(e) =>
                                  handleChangePrompt(
                                    "standardised_assessment",
                                    reportgenerateData.standardised_assessment_update_prompt
                                  )
                                }
                                disabled={!reportgenerateData?.standardised_assessment_generation_done}
                                className="ms-4"
                              >
                                Edit Prompts
                              </button>
                            ) : (
                              <>
                                <PromptEditor
                                  field="standardised_assessment"
                                  promptValue={promptData?.standardised_assessment || ""}
                                  onChange={handlePromptInputChange}
                                  onTest={handleTestPrompt}
                                  onUpdate={handleUpdatePrompt}
                                  onCancel={handleChangePrompt}
                                  onReset={handleReset}
                                  cancelValue={reportgenerateData.standardised_assessment_update_prompt}
                                  promptResult={promptResult}
                                  isMiceActive={fieldWithActiveMic == "standardised_assessment"}
                                  onMicChange={onMicChange}
                                />
                              </>
                            )}

                          </div>
                        </>
                      )}
                    </>
                  )}

                  {reportDisplayStatus?.standardised_assessment && (
                    <>
                      <textarea
                        onInput={adjustHeight}
                        value={reportgenerateData.standardised_assessment ?? ""}
                        onChange={(e) =>
                          handleChange("standardised_assessment", e.target.value)
                        }
                        ref={textareaRef}
                        className="form-control pe-5"
                      />

                      <button
                        onClick={(e) =>
                          handleEditorChange(
                            "standardised_assessment",
                            reportgenerateData.standardised_assessment
                          )
                        }
                        className="view-report-button"
                      >
                        View
                      </button>
                    </>
                  )}
                </div>
              </div>
              <hr className="border border-dark border-3 opacity-100" />
            </>
            {/* end standardised assessment */}

            {/* clinical_interview info */}
            <>
              <div className="report-container-main px-0">
                <h1>clinical interviews</h1>
                
                <div
                  className="report-container-child-cls"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  {!reportDisplayStatus?.clinical_interviews && (
                    <>
                      <div
                        style={{
                          fontSize: "20px",
                          padding: "24px",
                          background: "#F9FAFC",
                          borderRadius: "10px",
                          width: "100%",
                          color: isReportLimitReached && !isReportApproved ? "red" : ""
                        }}
                        className="form-group report-container-new"
                        dangerouslySetInnerHTML={{
                          __html: reportgenerateData?.clinical_interviews_generated
                            ? reportgenerateData?.clinical_interviews_with_markdown ?? ""
                            : LOADING_CAPTION,
                        }}
                      />
                      {!reportgenerateData?.clinical_interviews_generation_done && (
                        <div className="loader-with-text">
                          <div className="loader-div">
                          <LoaderIndex />
                        </div>
                        <div className="text-div loading-text">
                          Generating Reports
                          <span className="dots">
                            <span>.</span>
                            <span>.</span>
                            <span>.</span>
                          </span>
                        </div>
                        </div>
                      )}
                      {!reportGenerated && !isReportLimitReached && (
                        <>
                          <div className={!reportgenerateData.clinical_interviews_update_prompt ? 'd-flex' : ""}>
                            {!reportgenerateData.clinical_interviews_update_prompt && (<>
                              <button
                                onClick={(e) =>
                                  handleEditorChange(
                                    "clinical_interviews",
                                    reportDisplayStatus.clinical_interviews
                                  )
                                }
                                disabled={!reportgenerateData?.clinical_interviews_generation_done}
                              >
                                Edit
                              </button>
                            </>
                            )}

                            {!reportgenerateData.clinical_interviews_update_prompt ? (
                              <button
                                onClick={(e) =>
                                  handleChangePrompt(
                                    "clinical_interviews",
                                    reportgenerateData.clinical_interviews_update_prompt
                                  )
                                }
                                disabled={!reportgenerateData?.clinical_interviews_generation_done}
                                className="ms-4"
                              >
                                Edit Prompts
                              </button>
                            ) : (
                              <>
                                <PromptEditor
                                  field="clinical_interviews"
                                  promptValue={promptData?.clinical_interviews || ""}
                                  onChange={handlePromptInputChange}
                                  onTest={handleTestPrompt}
                                  onUpdate={handleUpdatePrompt}
                                  onCancel={handleChangePrompt}
                                  onReset={handleReset}
                                  cancelValue={reportgenerateData.clinical_interviews_update_prompt}
                                  promptResult={promptResult}
                                  isMiceActive={fieldWithActiveMic == "clinical_interviews"}
                                  onMicChange={onMicChange}
                                />
                              </>
                            )}

                          </div>
                        </>
                      )}
                    </>
                  )}

                  {reportDisplayStatus?.clinical_interviews && (
                    <>
                      <textarea
                        onInput={adjustHeight}
                        value={reportgenerateData.clinical_interviews ?? ""}
                        onChange={(e) =>
                          handleChange("clinical_interviews", e.target.value)
                        }
                        ref={textareaRef}
                        className="form-control pe-5"
                      />
                      <button
                        onClick={(e) =>
                          handleEditorChange(
                            "clinical_interviews",
                            reportgenerateData.clinical_interviews
                          )
                        }
                        className="view-report-button"
                      >
                        View
                      </button>
                    </>
                  )}
                </div>

                {/* {renderSessionFiles("clinical_interview")} */}
              </div>
              <hr className="border border-dark border-3 opacity-100" />
            </>
            {/* end clinical_interviews  */}

            {/* formulation */}

            {/* formulation start here */}
            <div className="report-container-main px-0">
              <h1>formulation</h1>
              
              <div
                className="report-container-child-cls"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                {!reportDisplayStatus?.formulation && (
                  <>
                    <div
                      style={{
                        fontSize: "20px",
                        padding: "24px",
                        background: "#F9FAFC",
                        borderRadius: "10px",
                        width: "100%",
                        color: isReportLimitReached && !isReportApproved ? "red" : ""
                      }}
                      className="form-group report-container-new"
                      dangerouslySetInnerHTML={{
                        __html: reportgenerateData?.formulation_generated
                          ? reportgenerateData?.formulation_with_markdown ?? ""
                          : LOADING_CAPTION,
                      }}
                    />
                    {!reportgenerateData?.formulation_generation_done && (
                      <div className="loader-with-text">
                        <div className="loader-div">
                        <LoaderIndex />
                      </div>
                      <div className="text-div loading-text">
                        Generating Reports
                        <span className="dots">
                          <span>.</span>
                          <span>.</span>
                          <span>.</span>
                        </span>
                      </div>
                      </div>
                    )}
                    {!reportGenerated && !isReportLimitReached && (
                      <>
                        <div className={!reportgenerateData.formulation_update_prompt ? 'd-flex' : ""}>
                          {!reportgenerateData.formulation_update_prompt && (<>
                            <button
                              onClick={(e) =>
                                handleEditorChange(
                                  "formulation",
                                  reportDisplayStatus.formulation
                                )
                              }
                              disabled={!reportgenerateData?.formulation_generation_done}
                            >
                              Edit
                            </button>
                          </>
                          )}

                          {!reportgenerateData.formulation_update_prompt ? (
                            <button
                              onClick={(e) =>
                                handleChangePrompt(
                                  "formulation",
                                  reportgenerateData.formulation_update_prompt
                                )
                              }
                              disabled={!reportgenerateData?.formulation_generation_done}
                              className="ms-4"
                            >
                              Edit Prompts
                            </button>
                          ) : (
                            <>
                              <PromptEditor
                                field="formulation"
                                promptValue={promptData?.formulation || ""}
                                onChange={handlePromptInputChange}
                                onTest={handleTestPrompt}
                                onUpdate={handleUpdatePrompt}
                                onCancel={handleChangePrompt}
                                onReset={handleReset}
                                cancelValue={reportgenerateData.formulation_update_prompt}
                                promptResult={promptResult}
                                isMiceActive={fieldWithActiveMic == "formulation"}
                                onMicChange={onMicChange}
                              />
                            </>
                          )}

                        </div>
                      </>
                    )}
                  </>
                )}

                {reportDisplayStatus?.formulation && (
                  <>
                    <textarea
                      onInput={adjustHeight}
                      value={reportgenerateData.formulation ?? ""}
                      onChange={(e) => handleChange("formulation", e.target.value)}
                      ref={textareaRef}
                      className="form-control pe-5"
                    />

                    <button
                      onClick={(e) =>
                        handleEditorChange(
                          "formulation",
                          reportgenerateData.formulation
                        )
                      }
                      className="view-report-button"
                    >
                      View
                    </button>
                  </>
                )}
              </div>

              {/* {renderSessionFiles("formulation")} */}
            </div>
            <hr className="border border-dark border-3 opacity-100" />
            {/* end formulation */}

            {/* diagnose start here */}
            <div className="report-container-main px-0">
              <h1>Impressions and Diagnosis</h1>
            
              <div
                className="report-container-child-cls"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                {!reportDisplayStatus?.diagnose && (
                  <>
                    <div
                      style={{
                        fontSize: "20px",
                        padding: "24px",
                        background: "#F9FAFC",
                        borderRadius: "10px",
                        width: "100%",
                        color: isReportLimitReached && !isReportApproved ? "red" : ""
                      }}
                      className="form-group report-container-new"
                      dangerouslySetInnerHTML={{
                        __html: reportgenerateData?.diagnose_generated
                          ? reportgenerateData?.diagnose_with_markdown ?? ""
                          : LOADING_CAPTION,
                      }}
                    />
                    {!reportgenerateData?.diagnose_generation_done && (
                      <div className="loader-with-text">
                        <div className="loader-div">
                        <LoaderIndex />
                      </div>
                      <div className="text-div loading-text">
                        Generating Reports
                        <span className="dots">
                          <span>.</span>
                          <span>.</span>
                          <span>.</span>
                        </span>
                      </div>
                      </div>
                    )}
                    {!reportGenerated && !isReportLimitReached && (
                      <>
                        <div className={!reportgenerateData.diagnose_update_prompt ? 'd-flex' : ""}>
                          {!reportgenerateData.diagnose_update_prompt && (<>
                            <button
                              onClick={(e) =>
                                handleEditorChange(
                                  "diagnose",
                                  reportDisplayStatus.diagnose
                                )
                              }
                              disabled={!reportgenerateData?.diagnose_generation_done}
                            >
                              Edit
                            </button>
                          </>
                          )}

                          {!reportgenerateData.diagnose_update_prompt ? (
                            <button
                              onClick={(e) =>
                                handleChangePrompt(
                                  "diagnose",
                                  reportgenerateData.diagnose_update_prompt
                                )
                              }
                              disabled={!reportgenerateData?.diagnose_generation_done}
                              className="ms-4"
                            >
                              Edit Prompts
                            </button>
                          ) : (
                            <>
                              <PromptEditor
                                field="diagnose"
                                promptValue={promptData?.diagnose || ""}
                                onChange={handlePromptInputChange}
                                onTest={handleTestPrompt}
                                onUpdate={handleUpdatePrompt}
                                onCancel={handleChangePrompt}
                                onReset={handleReset}
                                cancelValue={reportgenerateData.diagnose_update_prompt}
                                promptResult={promptResult}
                                isMiceActive={fieldWithActiveMic == "diagnose"}
                                onMicChange={onMicChange}
                              />
                            </>
                          )}

                        </div>
                      </>
                    )}
                  </>
                )}

                {reportDisplayStatus?.diagnose && (
                  <>
                    <textarea
                      onInput={adjustHeight}
                      value={reportgenerateData.diagnose ?? ""}
                      onChange={(e) => handleChange("diagnose", e.target.value)}
                      ref={textareaRef}
                      className="form-control pe-5"
                    />

                    <button
                      onClick={(e) =>
                        handleEditorChange("diagnose", reportgenerateData.diagnose)
                      }
                      className="view-report-button"
                    >
                      View
                    </button>
                  </>
                )}
              </div>
            </div>
            <hr className="border border-dark border-3 opacity-100" />
            {/* end diagnose */}

            {/* recommendation start here */}
            <div className="report-container-main px-0 mt-3">
              <h1>recommendation</h1>
              
              <div
                className="report-container-child-cls"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                {!reportDisplayStatus?.recommendation && (
                  <>
                    <div
                      className="form-group report-container-new"
                      style={{
                        fontSize: "20px",
                        padding: "24px",
                        background: "#F9FAFC",
                        borderRadius: "10px",
                        width: "100%",
                        color: isReportLimitReached && !isReportApproved ? "red" : ""
                      }}
                      dangerouslySetInnerHTML={{
                        __html: reportgenerateData?.recommendation_generated
                          ? reportgenerateData?.recommendation_with_markdown ?? ""
                          : LOADING_CAPTION,
                      }}
                    />
                    {!reportgenerateData?.recommendation_generation_done && (
                      <div className="loader-with-text">
                        <div className="loader-div">
                        <LoaderIndex />
                      </div>
                      <div className="text-div loading-text">
                        Generating Reports
                        <span className="dots">
                          <span>.</span>
                          <span>.</span>
                          <span>.</span>
                        </span>
                      </div>
                      </div>
                    )}
                    {!reportGenerated && !isReportLimitReached && (
                      <>
                        <div className={!reportgenerateData.recommendation_update_prompt ? 'd-flex mt-2' : "mt-2"}>
                          {!reportgenerateData.recommendation_update_prompt && (<>
                            <button
                              onClick={(e) =>
                                handleEditorChange(
                                  "recommendation",
                                  reportDisplayStatus.recommendation
                                )
                              }
                              disabled={!reportgenerateData?.recommendation_generation_done}
                            >
                              Edit
                            </button>
                          </>
                          )}

                          {!reportgenerateData.recommendation_update_prompt ? (
                            <button
                              onClick={(e) =>
                                handleChangePrompt(
                                  "recommendation",
                                  reportgenerateData.recommendation_update_prompt
                                )
                              }
                              disabled={!reportgenerateData?.recommendation_generation_done}
                              className="ms-4"
                            >
                              Edit Prompts
                            </button>
                          ) : (
                            <>
                              <PromptEditor
                                field="recommendation"
                                promptValue={promptData?.recommendation || ""}
                                onChange={handlePromptInputChange}
                                onTest={handleTestPrompt}
                                onUpdate={handleUpdatePrompt}
                                onCancel={handleChangePrompt}
                                onReset={handleReset}
                                cancelValue={reportgenerateData.recommendation_update_prompt}
                                promptResult={promptResult}
                                isMiceActive={fieldWithActiveMic == "recommendation"}
                                onMicChange={onMicChange}
                              />
                            </>
                          )}

                        </div>
                      </>
                    )}
                  </>
                )}

                {reportDisplayStatus?.recommendation && (
                  <>
                    <textarea
                      onInput={adjustHeight}
                      value={reportgenerateData.recommendation ?? ""}
                      onChange={(e) => handleChange("recommendation", e.target.value)}
                      ref={textareaRef}
                      className="form-control pe-5"
                    />

                    <button
                      onClick={(e) =>
                        handleEditorChange(
                          "recommendation",
                          reportgenerateData.recommendation
                        )
                      }
                      className="view-report-button"
                    >
                      View
                    </button>
                  </>
                )}
              </div>
            </div>
            {/* end recommendation */}
            <>
              {hasProfile && isReportGenerate && !reportGenerated && !isReportLimitReached && (
                <div>
                  <button
                    onClick={handleApprove}
                    disabled={isApprovedLoading}
                    className="approve-report-button"
                  >
                    Approve{" "}
                    {isApprovedLoading && (
                      <>
                        {""}
                        <LoaderIndex />
                      </>
                    )}{" "}
                  </button>
                </div>
              )}
            </>
            {isLoading && (
              <>
                <div className="full-page-loader">
                  <div className="loader"></div>
                </div>
              </>
            )}

            {reportGenerated && (
              <>
                <div className="d-flex" style={{ marginBottom: "20px" }}>
                  <button
                    onClick={handleDownloadPdf}
                    className="approve-report-button"
                    disabled={isReportDownload}
                  >
                    Download as PDF Report{" "}
                    {isReportDownload && (
                      <>
                        {""}
                        <LoaderIndex />
                      </>
                    )}
                  </button>
                  <button
                    onClick={handleDownloadDoc}
                    className="approve-report-button"
                    disabled={isReportDocDownload}
                  >
                    Download as Doc Report{" "}
                    {isReportDocDownload && (
                      <>
                        {""}
                        <LoaderIndex />
                      </>
                    )}
                  </button>
                </div>
              </>
            )}
          </>

          <ToastContainer />
        </div>
      </div>
    </div>
  );
};

export default PatientReportInformationPageReactQuillTemplate;
